<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="onSubmit"
  >
    <v-card
      height="100%"
      flat
    >
      <v-card-title>
        <slot name="form-title">
          <span
            class="font-weight-semibold text-base text--primary">{{ $t('Ajouter un nouveau genre')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-form-active',false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-card-text
        class="overflow-y-auto"
        style="max-height: 500px;"
      >
        <v-row class="pt-5">
          <v-col
            cols="12"
          >
            <GenresTreeSelectInput
              v-model="item.id_parent"
              :appendToBody="true"
              :tree-options="$store.state.app.genresTree"
              :placeholder="'Genre littéraire parent'"
              :noOptionsText="'Aucun genre littéraire'"
              :noResultsText="'Aucun résultat trouvé'"
              :noChildrenText="'Aucun sous-élément'"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="item.label"
              outlined
              dense
              :rules="[validators.required]"
              :error-messages="errorMessages.label"
              :label="$t('Nom')"
              :placeholder="$t('Nom')"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-autocomplete
              v-model="item.id_pricing_table"
              :rules="[validators.required]"
              :error-messages="errorMessages.id_pricing_table"
              :label="$t('Table de tarification')"
              :placeholder="$t('Table de tarification')"
              item-text="Label"
              item-value="id"
              outlined
              dense
              hide-details="auto"
              :items="pricingTables"
              :loading="isLoadingPricingTables"
              :search-input.sync="searchPricingTable"
              :filter="() => true"
              clearable
            >
              <template #selection="{ item: pt }">
                {{ pt.Label }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <slot name="form-actions">
          <slot name="form-cancel">
          </slot>
          <v-spacer />
          <v-btn
            :loading="loading"
            color="primary"
            class="me-3"
            type="submit"
          >
            {{ $t('Enregistrer') }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mdiClose, mdiPencilOutline, mdiPencilOffOutline } from '@mdi/js'
import {
  computed, ref, watch, onMounted,
} from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import axios from '@axios'
import store from '@/store'
import controller from './Controller'
import GenresTreeSelectInput from '@/views/apps/genres/GenresTreeSelectInput.vue'

export default {
  components: { GenresTreeSelectInput },
  model: {
    prop: 'object',
    event: 'update:is-form-active',
  },
  props: {
    object: {
      type: Object,
      default: () => {
      },
    },
    isFormActive: {
      type: Boolean,
      required: true,
    },
    withPassword: {
      type: Boolean,
      default: true,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
    planOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      genresTree: [],
    }
  },
  setup(props, { emit }) {
    const {
      form,
      isSnackbarBottomVisible,
      snackBarMessage,
    } = controller()
    const errorMessages = ref({})
    const valid = ref(false)
    const loading = ref(false)
    const isLoadingGenres = ref(false)
    const pricingTables = ref([])
    const isLoadingPricingTables = ref(false)
    const searchPricingTable = ref(null)
    let searchTimeout = null
    const validate = () => {
      form.value.validate()
    }

    const fetchPricingTables = term => {
      isLoadingPricingTables.value = true
      axios.get('/pricing_tables', { params: { term, columns: 'id,label' } }).then(response => {
        const results = response.data.data || response.data
        results.forEach(row => {
          if (!pricingTables.value.find(p => p.id === row.id)) {
            pricingTables.value.push(row)
          }
        })
      }).finally(() => {
        isLoadingPricingTables.value = false
      })
    }

    onMounted(() => fetchPricingTables(null))

    watch(searchPricingTable, val => {
      if (!val || val.trim().length < 1) return
      const alreadyInList = pricingTables.value.some(
        p => p.Label && p.Label.toLowerCase().includes(val.toLowerCase()),
      )
      if (alreadyInList) return
      clearTimeout(searchTimeout)
      searchTimeout = setTimeout(() => fetchPricingTables(val), 300)
    })

    const item = computed({
      get: () => props.object,
      set: value => emit('update:object', value),
    })

    // const item = ref(JSON.parse(JSON.stringify(blankItem)))
    const resetItem = () => {
      // item.value = {}

      // emit('update:object', item.value)
    }

    const onSubmit = () => {
      if (valid.value) {
        loading.value = true
        store.dispatch('genre/addItem', item.value)
          .then(response => {
            loading.value = false
            if (response.data.error || response.data.errors || (response.data.status && response.data.status === 'false')) {
              if (response.data.errors) {
                // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
                errorMessages.value = { ...response.data.errors }
              } else {
                isSnackbarBottomVisible.value = true
                snackBarMessage.value = response.data.message

                // this.toast(response.data.message, this.$vuetify.theme.currentTheme.error)
              }

              return false
            }
            resetItem()

            store.dispatch('app/fetchGenres')
            store.dispatch('app/fetchGenresTree')

            // emit('update:is-form-active', false)

            emit('refetch-data')
          }).catch(error => {
          loading.value = false
          console.log('error', error)
          if (error.data.errors) {
            // this.toast(this.$t('These credentials do not match our records'), this.$vuetify.theme.currentTheme.error)
            errorMessages.value = { ...error.data.errors }
          }
        })
      } else {
        validate()
      }
    }
    // eslint-disable-next-line no-unused-vars
    /* watch(() => props.object, (newValue, prevValue) => {
      if (!newValue || !newValue.id) {
        resetItem()
      } else {
        item.value = JSON.parse(JSON.stringify(newValue))
      }
    }) */
    // eslint-disable-next-line no-unused-vars
    /* watch(() => item, (newValue, prevValue) => {
      console.log('item change', newValue.value)
      emit('input', newValue.value)
    }, { deep: true }) */

    return {
      resetItem,
      form,
      isLoadingGenres,
      pricingTables,
      isLoadingPricingTables,
      searchPricingTable,
      isSnackbarBottomVisible,
      snackBarMessage,
      errorMessages,
      onSubmit,
      item,
      valid,
      loading,
      store,
      validate,

      // validation
      validators: { required, emailValidator },
      icons: {
        mdiClose,
        mdiPencilOffOutline,
        mdiPencilOutline,
      },
    }
  },
}
</script>
